export function setFocusToInputEnd(input: HTMLInputElement) {
  const length = input.value.length;

  input.focus();
  input.setSelectionRange(length, length);
}
